import AlignTextCenterIcon from '@atlaskit/icon/core/align-text-center';
import React from 'react';

export const SvgAlignCenter = () => (
  <AlignTextCenterIcon label="" testId="ads-refreshed-icon" />
);
